import React from 'react'
import styles from './styles/successPin.module.css';
import Logo from "../assets/cp365v.png"

 const SuccessPinPage = () => {
  return (
    <div className={styles.wrapper}>
        <div className={styles.logo}>
         <img src={Logo} alt='logo'/> 
        </div>
        <div className={styles.container}>
           <div className={styles.header}>
              <h1>Pin Reset Successful</h1>
           </div>
           <div className={styles.p}>
           <p>Your pin has been successfully reset.</p>
           <p>You can now use your new pin to log in.</p>
           </div>
        </div>
    </div>
  )
}


export default SuccessPinPage;